var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.localInvoices && _vm.localInvoices.length
        ? _vm._l(_vm.localInvoices, function (o) {
            return _c("p", { staticClass: "text-muted" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-info openInvoice",
                  on: {
                    click: function ($event) {
                      return _vm.showInvoice(o.id)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
              ),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(o.id))]),
              _vm._v(" " + _vm._s(o.comment) + ", препаратов "),
              _c("strong", [_vm._v(_vm._s(o.drugsPositions))]),
              _vm._v("\n      ("),
              _c("strong", [_vm._v(_vm._s(o.drugs))]),
              _vm._v(" з.у.) на сумму "),
              _c("strong", [
                _vm._v(_vm._s(Math.round(o.totalSum * 100) / 100)),
              ]),
            ])
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }